export default {
  desktop: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/layouts/desktop.vue").then(m => m.default || m),
  mobile: () => import("/home/msservice/workspace/MAYBE/PROD/PROD-MAYBE-V3-FE/maybe-v3-fe-prod/layouts/mobile.vue").then(m => m.default || m)
}